import {Component, DoCheck, EventEmitter, Input, IterableDiffers, Output} from '@angular/core';
import {CalAttendee} from "../utils/model/CalAttendee";
import {CalAttendeeState} from "../utils/model/CalAttendeeState";

@Component({
  selector: 'calendar-attendee-list',
  templateUrl: './attendee-list.component.html',
  styleUrls: ['./attendee-list.component.scss']
})

export class CalendarAttendeeListComponent implements DoCheck {
  @Input() attendees: CalAttendee[] | any = [];
  @Input() editable: boolean = false;
  @Input() expandable: boolean = false;
  @Output() onDelete = new EventEmitter();

  differ: any;
  stateText: string = '';
  expandEnable: boolean = true;
  expanded: boolean = true;

  constructor(differs: IterableDiffers) {
    this.differ = differs.find([]).create();
  }

  ngDoCheck() {
    const change = this.differ.diff(this.attendees);

    // Detect push item on array
    if (change) {
      this.generateDetail();
    }
  }

  removeAttendee(attendee: any) {
    let index = this.attendees.indexOf(attendee);
    if (index > -1) {
      this.attendees.splice(index, 1);
      this.onDelete.emit();
    }
  }

  generateDetail() {
    let accept: number = 0,
        reject: number = 0,
        unknown: number = 0;
    let arr: string[] = [];

    this.attendees.forEach(function (item: any) {
        if (item.state === CalAttendeeState.ACCEPTED) {
            item._stateText = 'Tham dự';
            accept++;
        } else if (item.state === CalAttendeeState.DECLINED) {
            item._stateText = 'Không tham dự';
            reject++;
        } else if (item.state === CalAttendeeState.NEEDS_ACTION) {
            item._stateText = 'Chưa quyết định';
            unknown++;
        }
    });

    if (accept) {
      arr.push(accept + ' có');
    }
    if (reject) {
      arr.push(reject + ' không');
    }
    if (unknown) {
      arr.push(unknown + ' chưa quyết định');
    }
    this.stateText = arr.join(', ');
  }

  expandAttendees() {
    if (this.expandEnable) {
      this.expanded = !this.expanded;
    }
  }

  getStateIcon(attendee: any) {
    let cls;
    switch(attendee.state) {
      case 'ACCEPTED':
        cls = 'fa-check accept';
        break;
      case 'DECLINED':
        cls = 'fa-check accept';
        break;
      default:
        cls = 'fa-check unknown';
    }
    return 'attendee-info fa ' + cls;
  }
}
